import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import { COLORS } from '@styles';

const sx = {
  [`& .${circularProgressClasses.circle}`]: {
    strokeLinecap: 'round',
    stroke: 'url(#paint0_linear_1075_45764)',
  },
}

export function CustomCircularProgress(props: CircularProgressProps) {
  return (
    <>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="paint0_linear_1075_45764" x1="15.9609" y1="39.5333" x2="33.1445" y2="6.27043" gradientUnits="userSpaceOnUse">
            <stop stopColor={COLORS.ELEKTRAFI_NEUTRAL} />
            <stop offset="1" stopColor={COLORS.ELEKTRAFI_CYAN_NEUTRAL} />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress sx={sx} {...props} />
    </>
  );
}
